import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, user, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("info@ferranti.eu");
  const [password, setPassword] = useState("Ferranti2025!");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/dashboard"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/dashboard");
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-col justify-between w-[46%] bg-navy-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #0D9488 0, transparent 45%), radial-gradient(circle at 80% 70%, #1E3E62 0, transparent 40%)" }} />
        <div className="relative flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-teal-500 flex items-center justify-center font-heading font-bold text-navy-900 text-2xl">F</div>
          <div>
            <p className="font-heading font-bold text-lg tracking-tight">Ferranti & Partners</p>
            <p className="text-[11px] text-teal-400 uppercase tracking-widest">Business Development CRM</p>
          </div>
        </div>
        <div className="relative">
          <h2 className="text-4xl font-bold font-heading leading-tight tracking-tight">Il centro operativo<br />del tuo Business<br />Development.</h2>
          <p className="text-slate-400 mt-4 max-w-md leading-relaxed">Prospect, relazioni, lead, opportunità e clienti. Un unico sistema per l'Italia e i mercati Export.</p>
          <div className="flex gap-8 mt-10">
            {["Prospect", "Lead", "Opportunità", "Cliente"].map((s, i) => (
              <div key={s} className="text-center">
                <p className="font-mono text-teal-400 text-xs">0{i + 1}</p>
                <p className="text-sm mt-1">{s}</p>
              </div>
            ))}
          </div>
        </div>
        <p className="relative text-xs text-slate-500">© 2026 Ferranti & Partners · Business Development & Export Advisory</p>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 bg-slate-50">
        <div className="w-full max-w-md">
          <h1 className="text-2xl font-bold font-heading text-slate-900">Accedi al CRM</h1>
          <p className="text-sm text-slate-500 mt-1 mb-8">Inserisci le tue credenziali per continuare.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Email</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Password</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
            <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full h-11 bg-navy-900 hover:bg-navy-700 text-white font-medium">
              {loading ? "Accesso…" : "Accedi"}
            </Button>
          </form>
          <p className="text-xs text-slate-400 mt-6 text-center">Ambiente demo · dati marcati come DEMO</p>
        </div>
      </div>
    </div>
  );
}
